import { useEffect, useRef } from "react"
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify";

export const Redirector = () => {
  const navigate = useNavigate()
  const hasNavigated = useRef(false);

  useEffect(() => {
    if (!hasNavigated.current) {
      const validateAndNavigate = async (clientId: string, redirectUri: string, codeChallenge: string, state?: string) => {
        try {
          await fetch(`${process.env.REACT_APP_API_URL}/api/oauth2/validation?client_id=${clientId}`)

          navigate("/sign-in", {
            state: {
              clientId: clientId,
              codeChallenge: codeChallenge,
              redirectUri: redirectUri,
              state: state
            }
          })
        } catch (error) {
          console.error(error)
          toast.error("Invalid client ID")
          navigate("/error")
        }
      }

      const params = new URLSearchParams(window.location.search)

      const clientId = params.get("client_id")?.toString()
      const redirectUri = params.get("redirect_uri")?.toString()
      const codeChallenge = params.get("code_challenge")?.toString()
      const codeChallengeMethod = params.get("code_challenge_method")?.toString()
      const state = params.get("state")?.toString()

      console.log(redirectUri, params)

      if (clientId && redirectUri && codeChallenge && codeChallengeMethod === "S256") {
        validateAndNavigate(clientId, redirectUri, codeChallenge, state)
      } else {
        navigate("/error")
      }

      hasNavigated.current = true
    }
  }, [navigate])

  return <>
    <div className="d-flex justify-content-center align-items-center">
      <Spinner animation="border" />
    </div>
  </>
}
